import type { Challenge } from "./types.js";
export const progression = {
  firstFinish: 250,
  repeatFinish: 35,
  pb: 100,
  tierMultiplier: 0.45,
  dailyRepeatLimit: 5,
  levelBase: 300,
  levelGrowth: 120,
};
export function levelFor(xp: number) {
  let level = 1;
  while (xp >= levelCost(level)) {
    xp -= levelCost(level);
    level++;
  }
  return level;
}
export function levelCost(level: number) {
  return progression.levelBase + (level - 1) * progression.levelGrowth;
}
export function levelProgress(xp: number) {
  let level = 1;
  while (xp >= levelCost(level)) {
    xp -= levelCost(level);
    level++;
  }
  return { level, current: xp, needed: levelCost(level) };
}
export const challenges: Challenge[] = [
  {id:"daily-tier-1",name:"Daily Tier 1",description:"Finish a Tier 1 map today.",period:"daily",metric:"exactTier1",target:1,xp:150,crateTier:2},
  {id:"daily-tier-2",name:"Daily Tier 2",description:"Finish a Tier 2 map today.",period:"daily",metric:"exactTier2",target:1,xp:200,crateTier:3},
  {id:"daily-tier-3",name:"Daily Tier 3",description:"Finish a Tier 3 map today.",period:"daily",metric:"exactTier3",target:1,xp:250,crateTier:4},
  {id:"daily-tier-4",name:"Daily Tier 4",description:"Finish a Tier 4 map today.",period:"daily",metric:"exactTier4",target:1,xp:300,crateTier:5},
  {id:"daily-tier-5",name:"Daily Tier 5",description:"Finish a Tier 5 map today.",period:"daily",metric:"exactTier5",target:1,xp:350,crateTier:6},
  {id:"daily-tier-6",name:"Daily Tier 6",description:"Finish a Tier 6 map today.",period:"daily",metric:"exactTier6",target:1,xp:400,crateTier:6},
  {id:"daily-pb",name:"Beat your best",description:"Improve an existing personal best today.",period:"daily",metric:"pbs",target:1,xp:250,crateTier:4},
  {id:"daily-under-60",name:"Under 60 seconds",description:"Finish any map in under 60 seconds today.",period:"daily",metric:"under60",target:1,xp:225,crateTier:3},
  {id:"daily-under-40",name:"Under 40 seconds",description:"Finish any map in under 40 seconds today.",period:"daily",metric:"under40",target:1,xp:300,crateTier:4},
  {id:"daily-under-20",name:"Under 20 seconds",description:"Finish any map in under 20 seconds today.",period:"daily",metric:"under20",target:1,xp:375,crateTier:5},
  {id:"daily-three",name:"Daily warm-up",description:"Finish any 3 maps today. Repeats count; any tier.",period:"daily",metric:"finishes",target:3,xp:150,crateTier:3},
  {id:"daily-variety",name:"Daily circuit",description:"Finish 3 different maps today. Any tier.",period:"daily",metric:"unique",target:3,xp:250,crateTier:4},
  {id:"daily-ten",name:"Daily session",description:"Finish any 10 maps today. Repeats count; any tier.",period:"daily",metric:"finishes",target:10,xp:400,crateTier:5},
  {
    id: "first",
    name: "First finish",
    description: "Complete your first map",
    period: "permanent",
    metric: "finishes",
    target: 1,
    xp: 150,
  },
  {
    id: "explorer",
    name: "Explore",
    description: "Complete 10 different maps",
    period: "permanent",
    metric: "unique",
    target: 10,
    xp: 600,
  },
  {
    id: "improve",
    name: "Personal best",
    description: "Improve five personal bests",
    period: "permanent",
    metric: "pbs",
    target: 5,
    xp: 300,
  },
  {
    id: "tier2-variety",
    name: "Tier 2 circuit",
    description: "Complete three different tier 2 maps",
    period: "permanent",
    metric: "uniqueTier2",
    target: 3,
    xp: 300,
  },
  {
    id: "tier5-first",
    name: "Tier 5",
    description: "Complete your first tier 5 map",
    period: "permanent",
    metric: "tier5",
    target: 1,
    xp: 500,
  },
];
export const achievements = [
  {
    id: "first",
    name: "FIRST STEPS",
    description: "Complete your first map",
    metric: "finishes",
    target: 1,
    hidden: false,
  },
  {
    id: "ten",
    name: "GETTING THE HANG OF IT",
    description: "Complete 10 unique maps",
    metric: "unique",
    target: 10,
    hidden: false,
  },
  {
    id: "speed",
    name: "SPEED FROG",
    description: "Reach 2,000 u/s",
    metric: "maxSpeed",
    target: 2000,
    hidden: false,
  },
  {
    id: "record",
    name: "RIBBIT RECORD",
    description: "Take your first #1",
    metric: "records",
    target: 1,
    hidden: false,
  },
  {
    id: "grass",
    name: "TOUCH GRASS",
    description: "Play for 100 hours",
    metric: "playtime",
    target: 360000,
    hidden: true,
  },
  {
    id: "hard",
    name: "THE HARD WAY",
    description: "Complete a tier 5 or harder map",
    metric: "tier5",
    target: 1,
    hidden: false,
  },
  {
    id: "why",
    name: "WHY",
    description: "Complete a tier 6 map",
    metric: "tier6",
    target: 1,
    hidden: false,
  },
  {
    id: "master",
    name: "PERFECTIONIST",
    description: "Earn platinum mastery",
    metric: "platinum",
    target: 1,
    hidden: false,
  },
];
export function periodKey(period: string, date = new Date()) {
  if (period === "permanent") return "all";
  if (period === "weekly") {
    date = new Date(date);
    date.setUTCDate(date.getUTCDate() - ((date.getUTCDay() + 6) % 7));
  }
  return date.toISOString().slice(0, 10);
}
